import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';
import Card from '../../layout/Card';

const LegalHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Gestión Legal"
    text="Éste es el módulo de Gestión Legal."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

LegalHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

const mapStateToProps = ({ LegalUnit }) => ({
  cards: LegalUnit.UnitHome.get('cards'),
  breadcrumbs: LegalUnit.UnitHome.get('breadcrumbs'),
});

export default connect(mapStateToProps)(LegalHome);
